module.exports = __webpack_public_path__ + "static/media/half_curly.5d58fca4.svg";